module.exports = __webpack_public_path__ + "static/media/GT08_ST_Additional-Services.06adeef2.csv";